import React from 'react';
import { useLocation } from 'react-router-dom';
import { DEFAULT_ISLAND_KEY, getIslandUrl } from 'alakai-aloha-shared';
import { getRuntimeSiteContext } from '../../lib/siteContext';

function buildCurrentPath(location) {
  return `${location.pathname || ''}${location.search || ''}${location.hash || ''}`;
}

export default function IslandHostRoute({
  children,
  islandKey = DEFAULT_ISLAND_KEY,
}) {
  const location = useLocation();
  const siteContext = React.useMemo(() => getRuntimeSiteContext(), []);
  const shouldRedirect = siteContext.isApexHost;

  React.useEffect(() => {
    if (!shouldRedirect || typeof window === 'undefined') {
      return;
    }

    window.location.replace(getIslandUrl(islandKey, buildCurrentPath(location)));
  }, [islandKey, location, shouldRedirect]);

  if (shouldRedirect) {
    return null;
  }

  return children;
}
